import api from './api'

// 获取淘特分类
async function GetCategoryList(data) {
  const { list, success, msg } = await api.GetCategoryList(data)
  const newList = []
  if (list.length) {
    list.map(item => {
      newList.push({
        value: item.CatId,
        label: (item.CatFullName && data.CatName) ? item.CatFullName.replaceAll(',', ' > ') : item.CatFullName,
        // isLeaf: !data?.onlyShowTwoCategory ? item.leaf : Boolean(item.IsLeaf)
        isLeaf: Boolean(item.IsLeaf)
      }) 
    })
  }
  newList.sort((a, b) => a.label.length - b.label.length) // 按类目名称的长度升序
  return { list: newList, success, msg }
}

// 获取商品池选项列表
async function GetPoolList() {
  const { pools } = await api.GetPoolList()
  const newList = []
  for (let item of pools) {
    newList.push({
      value: item.PoolId,
      label: item.PoolId === '1001' ? '淘特自营' : item.PoolName
    })
  }
  return { pools: newList }
}

// 设置指定参数
function setParams(item) {
  item.goodsId = item.nid
  item.goodsName = item.title
  item.price = item.zkFinalPrice
  item.sold = item.tejiaTotalSoldQuantity
  item.imageUrl = item.pictUrl
}

// 淘特搜词
async function SearchGoodsByKeyword(data) {
  const result = await api.SearchGoodsByKeyword(data)
  if (result?.list?.length) {
    result.list = result.list.filter(item => !item.title.includes('情趣成人性用品玩具'))
    result.list.map(item => setParams(item))
  }
  return result
}

// 淘特供应链货盘
async function SearchGoodsByJx(data) {
  const result = await api.SearchGoodsByJx(data)
  result.list.length && result.list.map(item => setParams(item))
  return result
}

// 淘特搜图
function SearchGoodsByImage(data) {
  return api.SearchGoodsByImage(data)
}

// 根据文字描述获取对应的颜色
function getTextColor(value) {
  const textColorMap = {
    '优秀': 'blue',
    '良好': 'green',
    '一般': 'red'
  }
  return textColorMap[value]
}

// 设置淘特搜词需要的一些参数
function SetParams({ item, obj, type, categoryList }) {
  // 获取商品所属分类
  obj.category = categoryList.find(category => category.value == item.levelOneCat)?.label
  if (type === 'taoteKeyword') { // 淘特选品才获取
    obj.haopinlv = item.posReviewRate || '未知',
    obj.tuihuolv = item.refundRate || '未知',
    obj.fahuoTime = item.shipRate || '未知',
    obj.kefuxiangying = item.cstRate || '未知',
    obj.shipIn24 = item.shipIn24 === 'true' ? true : false,
    obj.haopinlvColor = getTextColor(obj.haopinlv)
    obj.tuihuolvColor = getTextColor(obj.tuihuolv)
    obj.fahuoTimeColor = getTextColor(obj.fahuoTime)
    obj.kefuxiangyingColor = getTextColor(obj.kefuxiangying)
  }
}

// 淘特仅展示指定的第一级分类
const CategoryIds = [50008090, 50008165, 50016349, 28, 21, 122928002, 25, 50018004, 50016348, 1625, 16, 122852001, 50010404]

export default {
  GetCategoryList, GetPoolList, SearchGoodsByKeyword, 
  SearchGoodsByJx, SearchGoodsByImage, SetParams, CategoryIds
}